import { Icon } from "@assetwatch/ui";

type StatusTone =
  | "positive"
  | "warning"
  | "neutral"
  | "negative"
  | "informative";

const toneClasses: Record<StatusTone, string> = {
  positive: "border-positive text-positive",
  warning: "border-warning text-text-warning",
  neutral: "border-outline text-text-subtle",
  negative: "border-error text-error",
  informative: "border-informative text-informative",
};

/** Status label used by Work list cards; cards do not change status in place. */
export function WorkListStatusChip({
  label,
  showChevron = true,
  tone,
}: {
  label: string;
  showChevron?: boolean;
  tone: StatusTone;
}) {
  return (
    <span
      className={`inline-flex h-(--spacing-24) max-w-full items-center gap-(--spacing-4) rounded-(--radius-sm) border px-(--spacing-6) py-(--spacing-4) font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(--font-weight-medium) leading-(--font-line-height-20) ${toneClasses[tone]}`}
      data-slot="work-list-status-chip"
    >
      <span className="min-w-0 truncate">{label}</span>
      {showChevron ? (
        <Icon aria-hidden name="chevron-down" size="xs" tone="inherit" />
      ) : null}
    </span>
  );
}
